/**
 * Descriptor Tags
 */
export enum DescriptorTag {
    Forbidden0 = 0,
    ObjectDescriptorTag = 1,
    InitialObjectDescriptorTag = 2,
    EsDescriptorTag = 3,
    DecoderConfigDescriptorTag = 4,
    DecSpecificInfoTag = 5,
    SlConfigDescriptorTag = 6,
    ContentIdentDescriptorTag = 7,
    SupplContentIdentDescriptorTag = 8,
    IpiDescriptorPointerTag = 9,
    IpmpDescriptorPointerTag = 10,
    IpmpDescriptorTag = 11,
    QosDescriptorTag = 12,
    RegistrationDescriptorTag = 13,
    EsIdIncTag = 14,
    EsIdRefTag = 15,
    Mp4IodTag = 16,
    Mp4OdTag = 17,
    IplDescriptorPointerRefTag = 18,
    ExtensionProfileLevelDescriptorTag = 19,
    ProfileLevelIndicationIndexDescriptorTag = 20,
    // Reserved for future ISO use 0x15 to 0x3F
    ContentClassificationDescriptorTag = 64,
    KeyWordDescriptorTag = 65,
    RatingDescriptorTag = 66,
    LanguageDescriptorTag = 67,
    ShortTextualDescriptorTag = 68,
    ExpandedTextualDescriptorTag = 69,
    ContentCreatorNameDescriptorTag = 70,
    ContentCreationDateDescriptorTag = 71,
    OciCreatorNameDescriptorTag = 72,
    OciCreationDateDescriptorTag = 73,
    SmpteCameraPositionDescriptorTag = 74,
    SegmentDescriptorTag = 75,
    MediaTimeDescriptorTag = 76,
    // Reserved for future ISO use 0x4D to 0x5F
    IpmpToolsListDescriptorTag = 96,
    IpmpToolTag = 97,
    M4MuxTimingDescriptorTag = 98,
    M4MuxCodeTableDescriptorTag = 99,
    ExtSLConfigDescriptorTag = 100,
    M4MuxBufferSizeDescriptorTag = 101,
    M4MuxIdentDescriptorTag = 102,
    DependencyPointerTag = 103,
    DependencyMarkerTag = 104,
    M4MuxChannelDescriptorTag = 105,
    // Reserved for future ISO use 0x6A to 0xBF
    UserPrivate = 192,
    Forbidden255 = 255,
}
